import {NumberUtils} from '@/utils/NumberUtils';

export class MediaService {
  public static isSmallMobile(): boolean {
    return document.documentElement.clientWidth <= 320;
  }

  public static isMediumMobile(): boolean {
    return NumberUtils.inRange(321, 375, document.documentElement.clientWidth);
  }

  public static isPreLargeMobile(): boolean {
    return NumberUtils.inRange(376, 413, document.documentElement.clientWidth);
  }

  public static isLargeMobile(): boolean {
    return NumberUtils.inRange(414, 767, document.documentElement.clientWidth);
  }

  public static isTablet(): boolean {
    return NumberUtils.inRange(768, 1023, document.documentElement.clientWidth);
  }

  public static isTabletLarge(): boolean {
    return NumberUtils.inRange(1024, 1359, document.documentElement.clientWidth);
  }

  public static isDesktop(): boolean {
    return NumberUtils.inRange(1360, 1919, document.documentElement.clientWidth);
  }

  public static isDesktopLarge(): boolean {
    return document.documentElement.clientWidth >= 1920;
  }

  public static get clientWidth(): number {
    return document.documentElement.clientWidth;
  }

  public static isTouchDevice(): boolean {
    // https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  public static isAlmostSquareWebview(): boolean {
    // --almost-square-webview (min-aspect-ratio: 6/10) and (max-height: 600px);
    const {clientWidth, clientHeight} = document.documentElement;
    return clientWidth / clientHeight > 0.6 && clientHeight < 600;
  }
}
